import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(activity)/transition-lenses/components/TransitionLensesContent.tsx");
